import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-2 border-accent border-t-transparent animate-spin" />
      </div>
    );

  if (!user)
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;

  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;

  return children;
}
